import Vue from 'vue';
import { Module } from 'vuex';

import { RootState, UserCategoriesState } from 'frontend/types';

const userCategories: Module<UserCategoriesState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    userCategories: state => state.items,
  },
  mutations: {
    setValue(state: UserCategoriesState, value: UserCategoriesState): void {
      Vue.set(state, 'items', value);
    },
  },
};

export default userCategories;
